// DS3.9
import React, { useCallback, useRef } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { BiData, } from '@wix/da-bi/pkg/events';
import InputField from '@wix/da-ds/pkg/formControls/lego/InputField';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './HeaderSearchInput.scss';
var USERNAME_REGEX = /^[A-Za-z0-9][A-Za-z0-9-]{1,18}[A-Za-z0-9]$/;
var HeaderSearchInput = function (_a) {
    var className = _a.className, searchQuery = _a.searchQuery, searchBasePath = _a.searchBasePath, isLegacyHeader = _a.isLegacyHeader;
    var t = useTranslation().t;
    var searchInputRef = useRef(null);
    var logBiEvent = useBiLogger();
    var handleSubmit = useCallback(function (e) {
        var _a, _b;
        e.preventDefault();
        var searchTerm = (_b = (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
        if (!searchTerm) {
            return; // dont allow empty search
        }
        var searchUrl = Url.searchLink(searchTerm, searchBasePath);
        var username = searchTerm.slice(1);
        var isCorrectUsername = searchTerm.startsWith('@') && USERNAME_REGEX.test(username);
        logBiEvent(BiData({
            evid: 710,
            search_terms: searchTerm,
            sectionname: 'popup',
        }));
        // Only search usernames if we are not on subdomain!
        if (isCorrectUsername && !isLegacyHeader) {
            var userLinkUrl_1 = Url.userLink(username);
            // to test this locally do `.replace('.com', '.lan')`
            var http = new XMLHttpRequest();
            http.open('HEAD', userLinkUrl_1);
            http.onreadystatechange = function () {
                if (this.readyState === this.DONE) {
                    var doesUserExists = this.status === 200;
                    var redirectUrl = doesUserExists ? userLinkUrl_1 : searchUrl;
                    window.location.assign(redirectUrl);
                }
            };
            http.send();
        }
        else {
            window.location.assign(searchUrl);
        }
    }, [isLegacyHeader, logBiEvent, searchBasePath]);
    var handleInputKeyDown = useCallback(function (event) {
        if (event.key === 'Enter' || event.key === 'Return') {
            event.preventDefault();
            event.stopPropagation();
            handleSubmit(event);
        }
    }, [handleSubmit]);
    return (React.createElement("form", { className: c(s['search-form'], className), action: Url.searchLink(), onSubmit: handleSubmit },
        React.createElement(InputField, { id: "search-input", defaultValue: searchQuery, ref: searchInputRef, autoComplete: "off", className: s['input-field'], inputClassname: s['input'], placeholder: t('siteHeader.search'), onKeyDown: handleInputKeyDown, prefix: React.createElement(SearchIcon, { size: IconSize.SMALLER, disableDefaultColors: true, className: s['icon'] }), onClick: function () {
                logBiEvent(BiData({
                    evid: 700,
                    link_name: 'search',
                }));
            } })));
};
HeaderSearchInput.displayName = 'HeaderSearchInput';
export default HeaderSearchInput;
//# sourceMappingURL=HeaderSearchInput.js.map